<template>
  <Basic>
    <div class="grid grid--container">
      <div class="row">
        <div class="col col--lg-9 col--centered">
          <h1 class="basic__title">Community Standards</h1>
          <Rte>
            <p>Effective date: 5/01/2022</p>

            <p>
              Trust and safety are important to Campsite.bio. We've created
              these guidelines to go work alongside our
              <nuxt-link to="/terms">terms and conditions</nuxt-link>. These
              standards articulate what is and isn't allowed on our platform.
            </p>

            <p>
              Please take some time to review these standards. All Campsite
              users are required to follow them to continue using the Campsite
              platform.
            </p>

            <p>
              If you come across content on a Campsite.bio profile violates the
              standards below, please
              <nuxt-link to="/contact-us">report it</nuxt-link> with the
              following information:
            </p>

            <ul>
              <li>Username or URL of the Campsite profile you're reporting</li>
              <li>Your complaint about the profile</li>
              <li>Your name and email (to keep you updated)</li>
            </ul>

            <h2>Adult content</h2>

            <p>
              We strive to help website visitors make informed decisions. If
              you're including adult content on your Campsite, please ensure
              that:
            </p>

            <ol>
              <li>the content you're linking to is legal in your region,</li>
              <li>the content on your profile is suitable for all ages, and</li>
              <li>you enable the sensitive content label when appropriate</li>
            </ol>

            <h2>Usernames</h2>

            <p>
              We do not allow users to exchange Campsite usernames for money. If
              you select a username, you must do so with the intent of using it.
            </p>

            <h2>Illegal goods and services</h2>

            <p>
              Campsite doesn't allow the exchange of illegal goods or services
              through the platform. This includes (but not limited to):
            </p>

            <ul>
              <li>
                Alcohol (you may advertise the sale of alcohol with a liquor
                license, but you may not sell alcohol directly through Campsite
                payment links)
              </li>
              <li>Drugs</li>
              <li>Weapons</li>
              <li>Body parts (including body fluids, blood etc.)</li>
              <li>Offers for adoption / surrogacy</li>
              <li>Counterfeits</li>
              <li>Embargoed goods</li>
              <li>Endangered or protected species or parts of</li>
              <li>Fireworks and explosives</li>
              <li>Hazardous / toxic materials</li>
              <li>ID documents</li>
              <li>Personal info or mailing lists</li>
              <li>Regulated plants, insects, animals</li>
              <li>Recalled items</li>
              <li>Stolen items</li>
              <li>Tobacco products, inc. e-cigarettes</li>
              <li>Products offered through multi-level marketing schemes</li>
              <li>Gambling</li>
              <li>Human trafficking or prostitution.</li>
            </ul>

            <h2>Spam and fraud</h2>

            <p>
              We do not permit spam or scams. Don't use Campsite to spam or scam
              visitors, which includes linking out to external sites that
              collect personal information under false pretenses.
            </p>

            <h2>Harassment</h2>

            <p>
              We look to protect all visitors to Campsite. We do not allow users
              to target individuals with the intention to intimidate, harass,
              threaten, or bully.
            </p>

            <h2>Violent content</h2>

            <p>
              We have a no tolerance policy for any content that is violent or
              disturbing.
            </p>

            <h2>Child harm</h2>

            <p>
              Campsite has a no tolerance policy for child harm. We actively
              report any cases of child harm to the relevant national
              authorities.
            </p>

            <h2>Copyright and trademark</h2>

            <p>
              We strive to protect intellectual property rights. We do not allow
              the use of any content that infringes on copyrights, trademarks,
              or patents. If you believe your intellectual property rights are
              being infringed, please
              <nuxt-link to="/contact-us">reach out to us</nuxt-link>.
            </p>

            <h2>Privacy and impersonation</h2>

            <p>
              Individual privacy is especially important to us. We do not permit
              the sharing of any personal identifying information.
            </p>
          </Rte>
        </div>
      </div>
    </div>
  </Basic>
</template>

<script>
import defaultOG from '@/assets/default-og';
import Basic from '@/components/basic';
import Rte from '@/components/rte';

export default {
  head: {
    title: 'Community Standards - Campsite.bio',
    meta: [
      ...defaultOG,
      {
        hid: 'description',
        name: 'description',
        content: 'This is the current community standards for Campsite',
      },
    ],
  },

  components: { Basic, Rte },
};
</script>

<style lang="scss" scoped></style>
